/* eslint-disable import/no-cycle */
import React from 'react';
import { ScreeningType } from '../formElements/ScreeningType';
import { QuestionRequireResponse } from '../formElements/QuestionRequireResponse';
import { QuestionExpectedBranch } from '../formElements/QuestionExpectedBranch';
import { SCREENING_TYPE } from '../../../questionnaireTemplate.enums';
import { QuestionnaireBuilderElementProps } from '../../../questionnaireTemplate.types';

export const YesNoWithImage = React.memo(function YesNoWithImage({ elementId }: QuestionnaireBuilderElementProps) {
  return (
    <>
      <QuestionExpectedBranch elementId={elementId} />
      <ScreeningType id={elementId} screeningTypes={[SCREENING_TYPE.NONE, SCREENING_TYPE.KNOKOUT, SCREENING_TYPE.REVIEW]} />
      <QuestionRequireResponse elementId={elementId} />
    </>
  );
});
